<template>
    <form id="form" class="form form--vertical">
        <strong>{{locales && locales.property && locales.property.message}}</strong><br>
        <v-textarea-public 
            label="" 
            name="message" 
            v-model="body" 
            v-validate="`required`">
        </v-textarea-public>
        <button class="form__button"
                :disabled="isDisabled"
                @click.prevent="send">{{locales && locales.common && locales.common.send}}</button>
    </form>
</template>

<script>
import sweetalert from "sweetalert";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import $ from "jquery";
export default {
    inject: ['$validator'],
    computed: {
        ...mapGetters(["locales"])
    },
    data() {
        return {
            body: null,
            isDisabled: false
        }
    },
    props: ['property-id'],
    methods: {
        send: function () {
            let that = this;
            this.$validator.validateAll().then((res) => {
                if (res && !that.isDisabled) {
                    that.isDisabled = true;
                    window.axios.post('/api/messages', {
                        body: this.body,
                        property_id: this.propertyId
                    }).then((response) => {
                        $('.modal').hide();
                        this.$emit('sent');
                        let page = document.getElementById('page');
                        page.classList.remove("z-index");
                        sweetalert(this.locales.common.success, this.locales.property.message_sent, 'success');
                    }, (response) => {
                        sweetalert(this.locales.common.error, this.locales.common.login_required, 'error').then(()=>{ window.location.reload() });
                    })
                }
            })
        } 
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MessageForm.vue